import React, { useEffect } from "react";
import { Button, Center, IconButton, useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { Spin, Table } from "antd";

import { useTutorialsMaster } from "../../store/tutorial/reducer";
import { ITutorial } from "../../types/tutorial";
import { useDispatch } from "react-redux";
import { REQUEST_MASTER_TUTORIAL } from "../../store/tutorial/tutorialActionTypes";
import { IoMdTrash } from "react-icons/io";
import TutorialMasterEditDrawer from "../drawer/TutorialMasterEditDrawer";
import TutorialDeleteConfirmation from "../modals/TutorialDeleteConfirmation";

const TutorialTable: React.FC = () => {
  const { masterTutorials, busy } = useTutorialsMaster();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!busy && !(masterTutorials || []).length) {
      dispatch({ type: REQUEST_MASTER_TUTORIAL });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [targetItem, setTargetItem] = useState<ITutorial>();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setData(
      masterTutorials.map((value: any, index: number) => ({
        _id: value._id,
        key: index + 1,
        Index: index + 1,
        title: value.title,
        embeddedLink: value.embeddedLink,
        // description: value.description ? ReactHtmlParser(value.description.slice(0, 30).concat(" . . ."))
        //   : "Nan",
        value: value,
      }))
    );
    setLoading(false);
  }, [masterTutorials]);

  const columns = [
    {
      title: "SR N0.",
      dataIndex: "Index",
      width: 80,
    },
    {
      title: "TITLE",
      dataIndex: "title",
    },
    {
      title: "EMBEDDED LINK",
      dataIndex: "value",
      render: (value: any) => (
        <>
          {value.embeddedLink || value.embeddedLink !== "" ? (
            <Button
              onClick={() => {
                window.open(value.embeddedLink, "_blank");
              }}
            >
              Click to Open
            </Button>
          ) : (
            <Center>NaN</Center>
          )}
        </>
      ),
    },
    // {
    //   title: "DESCRIPTION",
    //   dataIndex: "description",
    // },
    {
      title: "ACTION",
      dataIndex: "value",
      render: (value: any) => (
        <>
          <Button
            onClick={() => {
              viewItem(value);
            }}
          >
            View
          </Button>
          <IconButton
            aria-label="delete link"
            key={"deleteLinkButton"}
            marginLeft={2}
            onClick={() => {
              deleteItem(value);
            }}
            icon={<IoMdTrash />}
          ></IconButton>
        </>
      ),
    },
  ];

  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();

  const {
    isOpen: isViewOpen,
    onOpen: onViewOpen,
    onClose: onViewClose,
  } = useDisclosure();

  const viewItem = (item: ITutorial) => {
    setTargetItem(item);
    onViewOpen();
  };

  const deleteItem = (item: ITutorial) => {
    setTargetItem(item);
    onDeleteOpen();
  };

  return (
    <>
      <div
        style={{
          width: "92vw",
          maxWidth: "92vw",
          height: "90vh",
          top: "10vh ",
          left: "4vw",
          position: "relative",
        }}
      >
        {loading ? (
          <Spin size="large" />
        ) : (
          <Table
            columns={columns}
            dataSource={data}
            loading={busy && data.length === 0 ? true : false}
            scroll={{ y: "calc(68vh - 4em)", x: 1200 }}
            rowClassName={() => "gray"}
          />
        )}
      </div>

      {isViewOpen && (
        <TutorialMasterEditDrawer
          isOpen={isViewOpen}
          onClose={onViewClose}
          tutorial={targetItem}
        />
      )}

      {isDeleteOpen && targetItem && (
        <TutorialDeleteConfirmation
          tutorial={targetItem}
          isOpen={isDeleteOpen}
          onClose={onDeleteClose}
        />
      )}
    </>
  );
};

export default TutorialTable;
